import { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Box
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SelectChangeEvent } from '@mui/material/Select';

interface CancelData {
  cancelledReason: string;
  cancelledRemark: string;
}

interface CancelReservationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (data: CancelData) => void;
}

const CancelReservationDialog = ({ open, onClose, onConfirm }: CancelReservationDialogProps) => {
  const { t } = useTranslation();
  const [cancelledReason, setCancelledReason] = useState('');
  const [cancelledRemark, setCancelledRemark] = useState('');

  const handleConfirm = () => {
    onConfirm({
      cancelledReason,
      cancelledRemark
    });
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('reservation.cancelReservation')}</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FormControl fullWidth>
            <InputLabel>{t('reservation.cancelledReason')}</InputLabel>
            <Select
              value={cancelledReason}
              label={t('reservation.cancelledReason')}
              onChange={(e: SelectChangeEvent) => setCancelledReason(e.target.value)}
            >
              <MenuItem value="customer-no-show">{t('reservation.reasons.customerNoShow')}</MenuItem>
              <MenuItem value="customer-late-cancelled">{t('reservation.reasons.customerLateCancelled')}</MenuItem>
              <MenuItem value="customer-cancelled">{t('reservation.reasons.customerCancelled')}</MenuItem>
              <MenuItem value="staff-cancelled">{t('reservation.reasons.staffCancelled')}</MenuItem>
            </Select>
          </FormControl>
          <TextField
            fullWidth
            multiline
            rows={3}
            label={t('reservation.cancelledRemark')}
            value={cancelledRemark}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCancelledRemark(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('actions.cancel')}</Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={!cancelledReason}
        >
          {t('common.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CancelReservationDialog;
